import { UrlConstants } from "../../../../../../afla-portal-v2/src/app/shared/constants/url.constants";
export class ApiViewDocumentsConstants {
    static URL = UrlConstants.API_V2 + "Document";
    static FUNCTION_GET_PUBLIC_DOCUMENTS = "GetPublicViewDocuments";
    static FUNCTION_GET_ATTACHMENT_CONTENT = "GetAttachmentContent";
    static FUNCTION_UPDATE_DOCUMENT_REQUEST_STATUS = "UpdateDocumentStatus";
}
